import {handleApiError} from '../../errorHandling/handleApiError';
import campaignsApi from '../campaigns.api';
import {DEFAULT_CAMPAIGN_NAME} from '../campaigns.consts';
import {CampaignSubTypeName, CampaignTypeName} from '../campaigns.types';
import getDefaultSubtype from './getDefaultSubtype';

// Returns the created campaign ID
async function addCampaign({
  campaignName = DEFAULT_CAMPAIGN_NAME,
  campaignType,
  campaignSubType = getDefaultSubtype(campaignType),
}: {
  campaignName?: string;
  campaignType: CampaignTypeName;
  campaignSubType?: CampaignSubTypeName;
}): Promise<number> {
  const requestParams = {
    type: campaignType,
    name: campaignName,
    subType: campaignSubType,
  };

  try {
    const campaignId = await campaignsApi.add(requestParams);

    return campaignId;
  } catch (err) {
    handleApiError(err);
    throw err;
  }
}

export default addCampaign;
